<template>
  <div class="box-wrapper">
    <div v-for="(box, index) in textBoxes" :key="index" class="text-box">
      <div class="title">{{ box.title }}</div>
      <div class="text">{{ box.text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TextBoxGroup",
  props: {
    textBoxes: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.box-wrapper {
  display: flex;
  justify-content: space-between;
  gap: 70px;
}

.text-box {
  width: 665px;
  height: fit-content;
  color: #000000;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.title {
  font-size: 22px;
  font-weight: 600;
  line-height: 1.5;
}

.text {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
}

@media (max-width: 1024px) {
  .text {
    font-size: 14px;
  }
}

@media (max-width: 744px) {
  .box-wrapper {
    gap: 50px;
  }
}

@media (max-width: 588px) {
  .box-wrapper {
    gap: 40px;
  }
  .title {
    font-size: 20px;
  }
  .text {
    font-size: 12px;
  }
}

@media (max-width: 431px) {
  .box-wrapper {
    gap: 30px;
    flex-direction: column;
  }
  .text-box {
    width: auto;
  }
}
</style>
